if (window.parent.frames.length > 0) {
  document.querySelectorAll('section').forEach((section) => {
    section.style.minHeight = `${window.parent.innerHeight}px`;
  });
}
